const intervalChoices = [
    'quarterly',
    'hourly',
    'daily',
    'weekly',
    'monthly'
];

const chartTypeChoices = [
    'Bar',
    'Line',
];

const graphPage = Vue.component("graph", {

    template: '<div id="stat-page">    <navbar-element :title="customerName" :showGridButton="false"/>    <div class="stat-bar">        <div class="content container-fluid">            <div class="row">                                <div class="selector-section col-xs-2">                    <div id="date-selector">                        <el-date-picker                                v-on:change="changeEndTime"                                v-model="dateTimePickerValue"                                :format="inputPickerFormat"                                :value-format="timePickerOutputFormat"                                :picker-options="timePickerOptions"                                :type="timePickerFormat"                                :placeholder="dateTimePickerPlaceholder">                        </el-date-picker>                    </div>                </div>                                <div class="selector-section col-xs-2">                    <span id="interval-label"                          class="title">{{"statistic.chart_page.interval_title" | t | toUpperCase }}</span>                    <div id="interval-selector">                        <dropdown :menuItems="intervalSelectbox" class="dropdown" :align="\'left\'"                                  :selectedIndex="intervalIndex"                                  v-on:select="changeStatisticInterval"/>                    </div>                </div>                                <div class="selector-section col-xs-2" v-if="!onlyOneTrunk">                    <span id="trunk-label" class="title">                        {{ \'statistic.chart_page.trunk_title\' | t | toUpperCase}}                    </span>                    <div id="trunk-selector">                        <dropdown :menuItems="mainTrunks" class="dropdown" :align="\'left\'"                                  :selectedIndex="mainTrunkIndex"                                  v-on:select="changeMainTrunk"/>                    </div>                </div>                                <div class="selector-section col-xs-2">                    <span id="did-label" class="title">{{ \'statistic.chart_page.did_title\' | t | toUpperCase}}</span>                    <div id="did-selector">                        <dropdown :menuItems="didsSelectbox" class="dropdown" :align="\'left\'" :selectedIndex="didIndex"                                  v-on:select="changeSelectedDid"/>                    </div>                </div>                                <div class="selector-section col-xs-2">                    <span id="localnumber-label"                          class="title">{{ \'statistic.chart_page.localnumber_title\' | t | toUpperCase}}</span>                    <div id="localnumber-selector">                        <dropdown :menuItems="endPointsSelectbox" class="dropdown" :align="\'left\'"                                  :selectedIndex="endPointIndex"                                  v-on:select="changeSelectedEndpoint"/>                    </div>                </div>                                <div class="selector-section col-xs-2">                    <span id="chart-type-label"                          class="title">{{ \'statistic.chart_type_selectbox.chart_title\' | t | toUpperCase}}</span>                    <div id="chart-type-selector">                        <dropdown :menuItems="graphTypes" class="dropdown" :align="\'left\'"                                  :selectedIndex="selectedChartTypeIndex"                                  v-on:select="switchChartType"/>                    </div>                </div>            </div>        </div>    </div>    <div class="graph-content">        <h3 class="title graph-title">{{chartTitle}}</h3>                <chartTab></chartTab>                <div id="graph-container" v-if="selectedGraphType === \'Line\' && !graphPlaceHolder">            <div id="graph-item" style="display: block">                <linechart :data="currentGraph" :options="options"></linechart>            </div>        </div>        <div id="graph-container" v-if="selectedGraphType === \'Bar\' && !graphPlaceHolder">            <div id="graph-item" style="display: block">                <barchart :data="currentGraph" :options="options"></barchart>            </div>        </div>        <div id="csv-container" :style="csvContainerStyle">            <div class="link-item" @click="createCsv">                <div class="csv-link-image"></div>                <div class="csv-link-descr">{{ \'statistic.csv_link.title\' | t}}</div>            </div>        </div>        <div id="graph-loading-container" v-loading="graphPlaceHolder">        </div>    </div></div>',

    data: function () {
        return {
            dateTimePickerPlaceholder: t('statistic.element_datepicker.placeholder_datetime'),
            noOptionSelectedText: t('statistic.dropdown.placeholder'),
            timePickerOptions: {firstDayOfWeek: 1},
            inputPickerFormat: 'yyyy-MM-dd HH:mm',
            timePickerOutputFormat: 'yyyy-MM-dd HH:mm',
            loading: true,
            dateTimePickerValue: '',
            currentDateTimePick: null,
            mainTrunkIndex: 0,
            didIndex: 0,
            endPointIndex: 0,
            intervalIndex: 0,
            intervalSelectbox: [
                t('statistic.interval_names.quarterly'),
                t('statistic.interval_names.hourly'),
                t('statistic.interval_names.daily'),
                t('statistic.interval_names.weekly'),
                t('statistic.interval_names.monthly'),
            ],
            graphTypes: [
                t('statistic.chart_type_selectbox.bar_chart'),
                t('statistic.chart_type_selectbox.line_chart'),
            ],
            selectedGraphType: 'Bar',
            selectedChartTypeIndex: 0,
            title: '',
            options: {},
            legendType: 'counter',
            legendLabels: this.getLegendLabels(),
            currentGraph: {
                labels: [],
                datasets: [],
            },
            chart: chartHandler.getChart(),
            csvContainerStyle: {
                paddingLeft: 0 + 'px',
                marginTop: 0 + 'px'
            }
        }
    },
    created: function () {

        chartProperties.setChartType(this.selectedGraphType);
        chartProperties.setLabelValueType(this.legendType);

        this.dateTimePickerValue = this.$store.getters.getCurrentDateTimePick;

        this.$store.dispatch('fetchCustomerName');

        this.$store.dispatch('fetchCustomerTrunks').then(() => {
            this.$store.dispatch('updateChosenMainTrunk', this.mainTrunks[0]).then(() => {
            });
        });

        bus.$on('GRAPH_TYPE', response => {
            this.legendType = response;
            chartProperties.setLabelValueType(this.legendType);

        });
    },
    computed: {

        chartTitle: function () {

            let translatedIntervalString = t('statistic.interval_names.' + this.currentInterval);
            let titlePrefix = t('statistic.graph_labels.title_prefix');

            let title = titlePrefix + ' (';

            if (this.selectedDid !== null) {
                title += this.selectedDid + ' - ';
            }

            if (this.selectedEndPoint !== null) {
                title += this.selectedEndPoint + ' - ';
            }

            title += translatedIntervalString + ')';

            chartProperties.setChartTitle(title);

            return title;
        },
        didsSelectbox: function () {
            return [this.noOptionSelectedText, ...this.dids];
        },
        endPointsSelectbox: function () {
            return [this.noOptionSelectedText, ...this.endPoints];
        },
        customerName() {
            return this.$store.getters.getCustomerName;
        },
        mainTrunks() {
            return this.$store.getters.getCustomerTrunks;
        },
        selectedMainTrunk() {
            return this.$store.getters.getActualMainTrunk;
        },
        selectedDid() {
            return this.$store.getters.getCurrentDid;
        },
        selectedEndPoint() {
            return this.$store.getters.getCurrentEndPoint;
        },
        endPoints() {
            return this.$store.getters.getPhoneNumbers;
        },
        dids() {
            return this.$store.getters.getDids;
        },
        currentInterval() {
            return this.$store.getters.getCurrentInterval;
        },
        storeDateTimePick() {
            return this.$store.getters.getCurrentDateTimePick;
        },
        currentIntervalStatistic() {
            return this.$store.getters.getCurrentIntervalStatistic;
        },
        graphPlaceHolder() {
            if (this.currentGraph.labels.length === 0) {
                return true;
            }
            return false;
        },
        noDataForGraph() {
            return 2;

        },
        onlyOneTrunk() {
            return this.mainTrunks.length === 0;
        },
        timePickerFormat() {
            let pickerType = '';

            switch (this.currentInterval) {
                case 'quarterly':
                    this.inputPickerFormat = 'yyyy-MM-dd HH:mm';
                    pickerType = 'datetime';
                    break;
                case 'hourly':
                    this.inputPickerFormat = 'yyyy-MM-dd HH';
                    pickerType = 'datetime';
                    break;
                case 'daily':
                    this.inputPickerFormat = 'yyyy-MM-dd';
                    pickerType = 'date';
                    break;
                case 'weekly':
                    this.inputPickerFormat = 'yyyy-MM-dd';
                    pickerType = 'date';
                    break;
                case 'monthly':
                    this.inputPickerFormat = 'yyyy-MM-dd';
                    pickerType = 'date';
                    break;
            }
            return pickerType;
        },
    },
    methods: {

        /**
         * Create csv file based on chosen statistic
         *
         */
        createCsv: function () {

            let fieldsToOutput = Object.keys(this.legendLabels);

            let lineDelimiter = '\n';
            let columnDelimiter = ';';

            let csvString = 'DateIdentifier' + columnDelimiter;

            csvString += fieldsToOutput.join(columnDelimiter);
            csvString += lineDelimiter;

            Object.values(this.currentIntervalStatistic).forEach(function (statPoint) {

                Object.keys(statPoint).forEach(function (statLegend) {

                    if (statLegend === X_AXIS_VAR) {
                        csvString += statPoint[statLegend] + columnDelimiter;
                        return;
                    }

                    if (fieldsToOutput.indexOf(statLegend) > -1) {
                        csvString += statPoint[statLegend] + columnDelimiter;
                    }
                });

                csvString += lineDelimiter;
            });

            let csvPrefix = 'data:text/csv;charset=utf-8;';
            let filename = this.csvFileName() + '.csv';

            let blob = new Blob([csvString], {type: csvPrefix});

            if (navigator.msSaveBlob) {
                // IE compatibility
                navigator.msSaveBlob(blob, filename)
            } else {
                let link = document.createElement('a');
                let url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';

                // in FF element must be appended to work.
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },

        /**
         * Create a subset of statistic based on chosen legends
         *
         * @returns Array
         */
        getStatisticSubsetByLegends: function () {

            let statisticOutput = [];
            let fieldToOutput = Object.keys(this.legendLabels);

            Object.values(this.currentIntervalStatistic).forEach(function (entry, index) {
                let statisticEntry = {};
                Object.keys(entry).forEach(function (statEntry, statIndex) {

                    if (fieldToOutput.indexOf(statEntry) > -1) {
                        statisticEntry[statEntry] = entry[statEntry];
                    }
                });

                statisticOutput[X_AXIS_VAR] = entry[X_AXIS_VAR];
                statisticOutput.push(statisticEntry);

            });
            return statisticOutput;
        },
        changeStatisticInterval: function (index) {

            this.intervalIndex = index;
            let intervalChoice = intervalChoices[index];

            this.didIndex = 0;
            this.endPointIndex = 0;

            this.$store.commit('setCurrentDid', null);
            this.$store.commit('setCurrentEndPoint', null);

            this.$store.dispatch('updateChosenInterval', intervalChoice);

        },
        changeMainTrunk: function (index) {
            this.mainTrunkIndex = index;

            let trunk = this.mainTrunks[index];

            this.didIndex = 0;
            this.endPointIndex = 0;
            this.$store.commit('setCurrentDid', null);
            this.$store.commit('setCurrentEndPoint', null);
            this.$store.dispatch('updateChosenMainTrunk', trunk);
        },
        changeSelectedDid: function (index) {
            this.didIndex = index;

            let did = null;

            if (typeof this.dids[index - 1] !== 'undefined') {
                did = this.dids[index - 1];
            }

            this.$store.dispatch('updateChosenDid', did);
        },
        changeSelectedEndpoint: function (index) {
            this.endPointIndex = index;
            let endPoint = null;

            if (typeof this.endPoints[index - 1] !== 'undefined') {
                endPoint = this.endPoints[index - 1];
            }
            this.$store.dispatch('updateChosenEndPoint', endPoint);
        },
        switchChartType: function (index) {
            this.selectedChartTypeIndex = index;
            this.selectedGraphType = chartTypeChoices[index];
            chartProperties.setChartType(chartTypeChoices[index]);
        },
        changeEndTime(time) {

            let now = time || moment();
            this.didIndex = 0;
            this.endPointIndex = 0;
            this.$store.commit('setCurrentDid', null);
            this.$store.commit('setCurrentEndPoint', null);
            this.$store.dispatch('updateDateTimePick', now);
        },
        buildGraph: function () {

            this.options = chartProperties.buildChartOptions();
            this.currentGraph = chartArrayBuilder.buildGraph(
                this.currentIntervalStatistic,
                this.legendLabels,
                this.legendType,
                this.currentInterval,
                this.selectedGraphType,
                this.storeDateTimePick
            );
        },

        setFormatOnPickerOptions(format) {
            this.timePickerOptions.format = format;
        },

        getLegendLabels: function () {

            return {
                'IncomingCalls': t('statistic.graph_legends.incoming_calls'),
                'OutgoingCalls': t('statistic.graph_legends.outgoing_calls'),
                'OutgoingCallsCellular': t('statistic.graph_legends.outgoing_calls_cellular'),
                'OutgoingCallsDomestic': t('statistic.graph_legends.outgoing_calls_domestic'),
                'OutgoingCallsInternational': t('statistic.graph_legends.outgoing_calls_international'),
                'AnsweredCalls': t('statistic.graph_legends.answered_calls'),
                'MissedCalls': t('statistic.graph_legends.missed_calls'),
            };
        },

        calculateCsvContainerStyle: function (legendsObject) {
            let currentChart = this.chart.chart 
            let chartButtom = this.chart.chart.chartArea.bottom || 0;
            let legendArray = legendsObject.legendHitBoxes;
            let lastLegend = null;
            let lastLegendBottom = 0;

            if (legendArray.length > 0) {
                lastLegend = legendArray[legendArray.length - 1];
                lastLegendBottom = Math.round(lastLegend.top + lastLegend.height);
            }

            let finalBottom = Math.round(chartButtom || legendsObject.bottom - lastLegendBottom);
            this.csvContainerStyle.marginTop = -200 + 'px';
            this.csvContainerStyle.display = 'block';
        },
        csvFileName: function () {

            let title = '';

            if (this.selectedMainTrunk !== null) {
                title += this.selectedMainTrunk + '_';
            }

            if (this.currentInterval !== null) {
                title += this.currentInterval + '_';
            }

            if (this.selectedDid !== null) {
                title += this.selectedDid + '_';
            }

            if (this.selectedEndPoint !== null) {
                title += this.selectedEndPoint;
            }

            title = title.replace(/_+$/, "");

            return title;
        }
    },
    watch: {
        legendType: function () {
            let legendLabels = {};

            // Report to Google that the legend type has changed
            ga('send', 'Statistics, legend type:, ' + this.legendType);
            switch (this.legendType) {
                case 'counter':
                    Object.assign(legendLabels, {
                        'IncomingCalls': t('statistic.graph_legends.incoming_calls'),
                        'OutgoingCalls': t('statistic.graph_legends.outgoing_calls'),
                        'OutgoingCallsCellular': t('statistic.graph_legends.outgoing_calls_cellular'),
                        'OutgoingCallsDomestic': t('statistic.graph_legends.outgoing_calls_domestic'),
                        'OutgoingCallsInternational': t('statistic.graph_legends.outgoing_calls_international'),
                        'AnsweredCalls': t('statistic.graph_legends.answered_calls'),
                        'MissedCalls': t('statistic.graph_legends.missed_calls'),
                    });
                    break;
                case 'timer':
                    Object.assign(legendLabels, {
                        'IncomingCallTime': t('statistic.graph_legends.incoming_call_time'),
                        'IncomingCallTimeAverage': t('statistic.graph_legends.incoming_call_time_average'),
                        'IncomingCallTimeMaximum': t('statistic.graph_legends.incoming_call_time_maximum'),
                        'OutgoingCallTime': t('statistic.graph_legends.outgoing_call_time'),
                        'OutgoingCallTimeAverage': t('statistic.graph_legends.outgoing_call_time_average'),
                        'OutgoingCallTimeMaximum': t('statistic.graph_legends.outgoing_call_time_maximum'),
                        'QueueHoldTimeAverage': t('statistic.graph_legends.queue_hold_time_average'),
                        'QueueHoldTimeMaximum': t('statistic.graph_legends.queue_hold_time_maximum'),
                    });
                    break;
            }

            this.legendLabels = legendLabels;
        },

        legendLabels: function () {
            this.buildGraph();
        },

        currentIntervalStatistic: function () {
            this.buildGraph();
        },
        
        'chart.chart.chartArea.right': function (value) {
            this.csvContainerStyle.paddingLeft = Math.round(value) + 8 + 'px';
        },

        'chart.chart.legend': function (legendsObject) {
            this.calculateCsvContainerStyle(legendsObject);
        },
    }
});